// extracted by mini-css-extract-plugin
export default {"title":"style_title__s8Ii7","text":"style_text__RLUcl"};